(function() {
  'use strict';

  const STORAGE_KEY = 'newsletter-popup-shown';
  const SUBSCRIBED_KEY = 'newsletter-subscribed';
  const popup = document.getElementById('NewsletterPopup');

  if (!popup) return;

  // Get settings from popup element
  const enabled = popup.dataset.enabled !== 'false';
  const delay = parseInt(popup.dataset.delay || '0', 10) * 1000;
  const daysToHide = parseInt(popup.dataset.daysToHide || '7', 10);

  if (!enabled) return;

  // Check if user just subscribed (from any form on the site)
  // Don't show popup at all if they subscribed from outside
  if (window.location.search.includes('customer_posted=true')) {
    localStorage.setItem(SUBSCRIBED_KEY, 'true');
    return; // Exit early - don't show popup
  }

  // Check if already shown this session (prevents showing on language change)
  const SESSION_KEY = 'newsletter-popup-session';
  if (sessionStorage.getItem(SESSION_KEY)) {
    return; // Already shown this session
  }

  // Check if user already subscribed (from any form)
  function isAlreadySubscribed() {
    return localStorage.getItem(SUBSCRIBED_KEY) === 'true';
  }

  // Check if popup was already shown
  function shouldShowPopup() {
    // Don't show if already subscribed
    if (isAlreadySubscribed()) return false;

    const shownTime = localStorage.getItem(STORAGE_KEY);
    if (!shownTime) return true;

    const shownDate = new Date(parseInt(shownTime, 10));
    const now = new Date();
    const daysDiff = (now - shownDate) / (1000 * 60 * 60 * 24);

    return daysDiff >= daysToHide;
  }

  // Listen for all newsletter form submissions
  function trackNewsletterForms() {
    document.querySelectorAll('form.newsletter-form').forEach(function(form) {
      form.addEventListener('submit', function() {
        // Mark as subscribed after a short delay (to allow form to process)
        setTimeout(function() {
          localStorage.setItem(SUBSCRIBED_KEY, 'true');

          // Check if success message appears and close popup after showing it
          const successMessage = popup.querySelector('.newsletter-form__message--success');
          if (successMessage && successMessage.style.display !== 'none') {
            // Close popup after 3 seconds to let user see the success message
            setTimeout(function() {
              hidePopup();
            }, 3000);
          }
        }, 1000);
      });
    });
  }

  // Also check for success message on page load (for form resubmission)
  function checkForSuccess() {
    const successMessage = popup.querySelector('.newsletter-form__message--success');
    if (successMessage) {
      // Close popup after 3 seconds
      setTimeout(function() {
        hidePopup();
      }, 3000);
    }
  }

  // Initialize tracking
  trackNewsletterForms();

  // Show popup
  function showPopup() {
    popup.classList.add('is-open');
    // Removed overflow-hidden to allow scrolling

    // Mark as shown immediately so it doesn't appear again
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    sessionStorage.setItem(SESSION_KEY, 'true');

    // Focus first input
    const input = popup.querySelector('input[type="email"]');
    if (input) {
      input.focus();
    }

    // Trap focus
    trapFocus(popup);

    // Check for success message
    checkForSuccess();
  }

  // Hide popup
  function hidePopup() {
    popup.classList.remove('is-open');
    // Removed overflow-hidden to allow scrolling

    // Remove focus trap
    removeTrapFocus();
  }

  // Focus trap utilities
  function trapFocus(container) {
    const focusableElements = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    container.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  function removeTrapFocus() {
    // Focus returns naturally when popup closes
  }

  // Event listeners - only close on X button or overlay click
  popup.querySelectorAll('[data-newsletter-popup-close]').forEach(function(el) {
    el.addEventListener('click', hidePopup);
  });

  // Check for successful form submission
  const successMessage = popup.querySelector('.newsletter-form__message--success');
  if (successMessage) {
    // Form was submitted successfully, show popup with success and close after delay
    showPopup();
    setTimeout(hidePopup, 3000);
  } else if (shouldShowPopup()) {
    // Show popup after delay
    setTimeout(showPopup, delay);
  }
})();
